<template>
  <base-modal :box="box" :step="step" @on-back="mixin_set_init_step">
    <template slot="description">
      <div>
        {{$t('pbx.worksheet.action.queue.state.add-method.description')}}
        <router-link :to="{ name: 'pbx.service-package.index' }">
          <span @click='$refs.close.click()'> {{ $t('pbx.breadcrumb.title') }} </span>
        </router-link> -
        <router-link :to="{ name: 'pbx.operator.index' }">
          <span @click='$refs.close.click()'> {{ $t('pbx.breadcrumb.operator.index') }} </span>
        </router-link>
      </div>
    </template>
    <search v-model.trim="search" />
    <list-scroll height="380px" :border_top="true">
      <contact-method-with-contact
        v-for="item in filter_items"
        :key="item.id"
        :method="item"
        :contact="item.contact"
      >
        <list-state slot="controls" :value="is_selected(item.id)" @click="toggle_select(item.id)" />
      </contact-method-with-contact>
    </list-scroll>

    <template slot="footer-cancel" slot-scope="{ close }">
      <span class="d-none"  @click="close()" ref="close"></span>
      <i-button size="large" @click="mixin_set_init_step">
        {{ $t('pbx.worksheet.modal.action.child.button.cancel') }}
      </i-button>
    </template>
    
    <i-button slot="footer-ok" size="large" type="success" :loading="is_loading" @click="save">
      {{ $t('pbx.worksheet.modal.action.child.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base';
  import Search from '../../../_base/_fragments/search';
  import ListState from '@shared/components/input/input-state-toggle';
  import ContactMethodWithContact from '@pbx/components/contact-methods/item-with-contact';
  import { StepMixin } from '../../../_base/step-mixin';
  import { filterName } from '@shared/helpers/filter';

  export default {
    components: { BaseModal, Search, ListState, ContactMethodWithContact },
    mixins: [StepMixin],

    props: {
      list_of_contact_methods: {
        type: Array,
        default: () => []
      },
      close: {
        default: 'asd'
      }
    },

    data() {
      return {
        search: '',
        selected: [],
        is_loading: false
      };
    },

    computed: {
      filter_items: function() {
        return this.list_of_contact_methods.filter(item => {
          return (
            filterName(this.search, item.contact.first_name) ||
            filterName(this.search, item.contact.last_name)
          );
        });
      }
    },

    watch: {
      'form.params.contact_methods': {
        handler: function(val) {
          this.selected = val;
        },
        immediate: true
      }
    },

    methods: {
      is_selected: function(id) {
        return this.selected.includes(id);
      },

      toggle_select(id) {
        if (this.is_selected(id)) {
          this.selected = this.selected.filter(source_id => source_id !== id);
        } else {
          this.selected.push(id);
        }
      },

      save: function() {
        this.mixin_save_step({ params: { contact_methods: this.selected } });
        this.mixin_set_step('init', { tab: 'contact_methods' });
      }
    }
  };
</script>
